import { render, staticRenderFns } from "./areaInformationCard.vue?vue&type=template&id=01dfe768&scoped=true"
import script from "./areaInformationCard.vue?vue&type=script&lang=js"
export * from "./areaInformationCard.vue?vue&type=script&lang=js"
import style0 from "./areaInformationCard.vue?vue&type=style&index=0&id=01dfe768&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01dfe768",
  null
  
)

export default component.exports